{{ element.movieTitle }}
{{ element.movieYear }}
<cosmos-image [src]="element.image?.url"></cosmos-image>
